<template>
  <SelectComponent
    :value="value && value.toString()"
    v-bind="$attrs"
    @input="$ev => $emit('input', $ev === 'true' ? true : false)"
    :items="[
      { value: 'true', label: $tc('yes') },
      { value: 'false', label: $tc('no') },
    ]"
  />
</template>

<script>
import SelectComponent from './Select'
export default {
  props: {
    value: [Boolean, String],
  },
  components: {
    SelectComponent,
  },
}
</script>
